import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Link from 'next/link'
import StateStorage from 'lib/state-storage'
import Typo from 'constants/typography'
import {
  SEGMENT_STORAGE_KEY_CATEGORY,
  SEGMENT_REF_TYPES,
} from 'lib/segment/const'
import { segmentFeaturedCellClicked } from 'components/home/home-page-segment/homePageSegment'
import styles from './bottom-bubble-navigations.scss'

const BottomBubbleNavigations = ({ isPhone, bottomNavigations }) => {
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()
  if (!bottomNavigations) return null

  const prepareCategoryReferer = (refId = '') => {
    sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.id, refId)
    sessionStorage.setItem(
      SEGMENT_STORAGE_KEY_CATEGORY.type,
      SEGMENT_REF_TYPES.APP_FEED,
    )
  }

  const handleClickNavigation = (navigation, index) => {
    segmentFeaturedCellClicked({
      ref_id: navigation?.id,
      cta_type: navigation?.attributes?.sub_type,
      position: index + 1,
      position_type: navigation?.attributes?.navigation_type,
    })
    prepareCategoryReferer(navigation?.id)
  }

  return (
    <div className="bottom-bubble-navigations">
      <style jsx>{styles}</style>
      {bottomNavigations.map((navigation, index) => {
        const cta = navigation?.attributes?.cta
        const isCategoryCta = cta?.kind === 'category'
        const linkAs = isCategoryCta
          ? `/${shop}/${language}/clothes/${cta?.link_rewrite}`
          : `${cta?.value}`
        const linkHref = isCategoryCta
          ? `/category?id=${cta?.value}`
          : `${cta?.value}`
        return (
          <Link key={navigation?.id} as={linkAs} href={linkHref}>
            <a
              className={isPhone ? Typo.body2 : Typo.body1}
              style={{
                color: navigation?.attributes?.title_info?.['text-color'],
              }}
              onClick={() => {
                handleClickNavigation(navigation, index)
              }}
              onKeyDown={() => {
                handleClickNavigation(navigation, index)
              }}
              role="button"
              tabIndex={0}
            >
              {navigation.attributes.title}
            </a>
          </Link>
        )
      })}
    </div>
  )
}

BottomBubbleNavigations.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  bottomNavigations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      attributes: PropTypes.shape({
        navigation_type: PropTypes.string,
        sub_type: PropTypes.string,
        title: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        link_rewrite: PropTypes.string,
      }),
    }),
  ),
}

BottomBubbleNavigations.defaultProps = {
  bottomNavigations: [],
}

export default connect((state) => ({
  isPhone: state.device.isPhone,
  bottomNavigations: state.homePage.bottomNavigations,
}))(BottomBubbleNavigations)
